import { Component } from '@angular/core';
import { RouterModule } from "@angular/router";

@Component({
  selector: 'app-admin-approved-pharmacies',
  imports: [RouterModule],
  templateUrl: './admin-approved-pharmacies.html',
  styleUrl: './admin-approved-pharmacies.scss'
})
export class AdminApprovedPharmacies {

}
